import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Kpi } from './kpi-entity';
import { Person } from '../master-data/person-entity';
import { GeoAreaType } from './geo-area-type-entity';



export class GeoArea extends BaseEntity {

    geoAreaCode    : string;
    name           : string;
    person         : Person;
    subGeoAreas    : GeoArea[] = [];
    geoAreaType    : GeoAreaType;

    kpisDate       : Date;
    kpis           : Kpi[];

    expanded       : boolean = false;
    firstOrLast    : number[];


}